import { PLAYER_PROGRESS_TRACKER_BADGE_COUNT } from '@/features/guardian-player/components/player-progress-tracker/constants';
import type {
  LevelSummary,
  ProgressLevel,
} from '@/features/guardian-player/components/player-progress-tracker/types';
import { levelColor } from '@/features/onboarding/utils/player-card';
import { DATE_FORMATS } from '@/utils/date-formats';
import { format, isValid, parseISO } from 'date-fns';

function clamp(value: number) {
  return Math.max(0, Math.min(1, value));
}

function formatShortDate(raw?: string) {
  if (!raw) return undefined;
  const date = parseISO(raw);

  if (!isValid(date)) {
    return undefined;
  }

  return format(date, DATE_FORMATS.TEXT);
}

function getEarnedCount({
  earnedBadgeCount,
  isEarned,
  isLocked,
  totalCount,
}: {
  earnedBadgeCount: number;
  isEarned: boolean;
  isLocked: boolean;
  totalCount: number;
}) {
  if (isLocked) {
    return 0;
  }

  if (isEarned) {
    return totalCount;
  }

  return earnedBadgeCount;
}

export function buildLevelSummary(
  level: number,
  currentLevel: number,
  item: ProgressLevel,
): LevelSummary {
  const totalCount = Math.max(item.badges.length, PLAYER_PROGRESS_TRACKER_BADGE_COUNT);
  const earnedBadgeCount = item.badges.filter(badge => badge.badgeEarned).length;
  const isLocked = level > currentLevel;
  const isEarned = item.completed;
  const isCurrent = level === currentLevel && !isEarned;
  const earnedCount = getEarnedCount({
    earnedBadgeCount,
    isEarned,
    isLocked,
    totalCount,
  });
  const completedOn = formatShortDate(item.dateCompleted);

  return {
    level,
    color: levelColor(level),
    earnedCount,
    totalCount,
    progress: clamp(earnedCount / totalCount),
    isEarned,
    isCurrent,
    isLocked,
    completedOn,
  };
}
